export default (learningobjectives) => {
    return 1;
  };
  